import { useSelector } from 'react-redux';
import { Loader, ChildrenProps } from '@gv/triage-components';

import { selectIsLoading } from 'store/slices/loader';

export const LoaderRedux = ({ children }: ChildrenProps) => {
  const isLoading = useSelector(selectIsLoading);
  return <Loader isLoading={isLoading}>{children}</Loader>;
};
